import * as dashboardService from '@/services/dashboard.service';

import { queryKeys } from '@/query/query-keys';

import type { AuditLog, AuditLogFilterParams } from '@/types/audit-log.type';
import type { PaginatedResponse } from '@/types/common.type';
import type { DashboardFilters, DashboardResponse } from '@/types/dashboard.type';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

export const useDashboardQuery = (
  filters: DashboardFilters,
  options?: Omit<UseQueryOptions<DashboardResponse, Error>, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: queryKeys.dashboard.byFilters(filters),
    queryFn: () => dashboardService.fetchDashboardData(filters),
    staleTime: 2 * 60 * 1000, // 2 minutes
    ...options,
  });
};

export const useAuditLogsQuery = (
  params: AuditLogFilterParams,
  options?: Omit<UseQueryOptions<PaginatedResponse<AuditLog>, Error>, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: queryKeys.dashboard.auditLogs(
      params.page || 1,
      params.page_size,
      params.query,
      params.filters
    ),
    queryFn: () => dashboardService.fetchAuditLogs(params),
    staleTime: 60 * 1000,
    ...options,
  });
};
